import {useEffect, useState} from "react";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";

// Utils
import {
    generalCurrentSettings,
    companyLogo,
    companyLogoIsDark,
    gamificationDataCount,
    isFreeTrial,
    isYourCompanyBlocked,
    buttonPermissionsState
} from 'store';

// Models
import {generalSetting} from "models/generalSetting";
import {myGamification} from "models/myGamification";

// Assets
import eleapLogo from '../assets/images/eLeaP_logo.svg';


const useCompanyLogo = () => {
    const [generalSettings, setGeneralSettings] = useRecoilState(generalCurrentSettings);
    const setGamificationCount = useSetRecoilState(gamificationDataCount);
    const [logo, setLogo] = useRecoilState(companyLogo);
    const [isLogoDark, setIsLogoDark] = useRecoilState(companyLogoIsDark);
    const isFreeTrialExpired = useRecoilValue(isFreeTrial);
    const isAccountBlocked = useRecoilValue(isYourCompanyBlocked);
    const setButtonPermissions = useSetRecoilState(buttonPermissionsState);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!Object.keys(generalSettings).length) {
            (async () => {
                try {
                    const {data} = await generalSetting.getGeneralSetting();
                    const languagesData = await generalSetting.getLanguagesGeneralSetting();

                    if (data?.success) {
                        setGeneralSettings({
                            ...data.general_setting,
                            available_languages: languagesData.data.languages
                        });
                        setButtonPermissions({
                            canCreateReview: data.general_setting.reviews.can_create_review.status,
                            message: data.general_setting.reviews.can_create_review.message,
                            isTeamComplete: data.general_setting.reviews.company_has_complete_teams,
                            hasOrgChart: data.general_setting.reviews.org_chart_has_hierarchy
                        });
                    }
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if ((isFreeTrialExpired === false) && (isAccountBlocked === false)) {
            (async () => {
                try {
                    const {data} = await myGamification.getUserGamificationCount();

                    if (data?.success) {
                        setGamificationCount(data);
                    }
                } catch (e) {
                    console.log(e);
                }
            })();
        }
    }, [isFreeTrialExpired, isAccountBlocked]);


    useEffect(() => {
        if (!Object.keys(generalSettings).length) {
            return;
        }

        setIsLogoDark(Number(generalSettings.file_is_dark));

        const src = generalSettings.logo_path || eleapLogo;

        const img = new Image();
        img.src = src;

        img.onload = () => {
            setLoaded(true);
            setLogo(src);
        };
        img.onerror = () => {
            setLoaded(true);
            setLogo(eleapLogo);
        };
        // eslint-disable-next-line
    }, [generalSettings]);

    return {
        logo: loaded ? logo : '',
        generalSettings,
        loaded,
        setLogo,
        isDefaultLogo: logo === eleapLogo,
        isLogoDark,
        setIsLogoDark,
    };
};

export default useCompanyLogo;
